import { render, staticRenderFns } from "./artists-picker.vue?vue&type=template&id=1a21a7c6&scoped=true"
import script from "./artists-picker.vue?vue&type=script&setup=true&lang=js"
export * from "./artists-picker.vue?vue&type=script&setup=true&lang=js"
import style0 from "./artists-picker.vue?vue&type=style&index=0&id=1a21a7c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a21a7c6",
  null
  
)

export default component.exports